var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inline-block truncate rounded-md bg-white py-0.5 border border-gray-200 mb-0.5 px-1 text-xs text-gray-500",class:{ 'cursor-pointer': _vm.link }},[_vm._v(" "+_vm._s(_vm._f("truncateString")(_vm.name,_vm.truncateLength))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }